/**
 * Shadow-DOM-aware ancestor walker.
 *
 * `Element.closest()` stops at shadow-root boundaries. The SPA's
 * topology — `<sat-app>` → `<sat-top-bar>` (shadow) → `<sat-share-button>`
 * (shadow), `<sat-view-toggle>` (shadow), etc. — means a button living
 * two shadow roots deep can't find its host `<sat-app>` via the
 * standard DOM API. This walker hops out of each shadow root via its
 * `host` until it finds a match or the document is exhausted.
 *
 * Returns null if no ancestor matches.
 */
export function findAncestorAcrossShadow(start: Element, selector: string): Element | null {
  let node: Node | null = start;
  while (node !== null) {
    if (node instanceof Element && node.matches(selector)) return node;
    const parent: Node | null = (node as Node).parentNode ?? null;
    if (parent instanceof ShadowRoot) {
      node = parent.host;
    } else {
      node = parent;
    }
  }
  return null;
}
